import React from 'react';
import ReactTooltip, { TooltipProps } from 'react-tooltip';

export const Tooltip = (props: TooltipProps & { visible?: boolean }) => {
  return (
    <ReactTooltip
      id={props.id || 'main'}
      className={props.className || 'tooltip-custom'}
      place={props.place || 'bottom'}
      effect={props.effect || 'solid'}
      type={props.type || 'light'}
      wrapper='div'
      multiline
      disable={!props.visible}
      border={props.border !== false}
      borderColor='#5b2f91'
    >
      {props.children}
    </ReactTooltip>
  );
};
